module.exports = __webpack_public_path__ + "static/media/bg_web_app.8952c755.svg";